import styled from "styled-components"

export const ButtonText = styled.span``

export const CancelText = styled.span`
  color: #cb70a1;
`

export const Redirect = styled.div`
  display: block;
  width: 78%;
  min-height: 50px;
  margin: 0 auto;
  font-size: 14px;
  line-height: 50px;
  color: #aab0b3;
  border-bottom: 1px solid #dce6ea;
`

export const SolidButton = styled.button`
  width: 100%;
  padding: 10px 0;
  margin-top: 20px;
  display: flex;
  background-image: linear-gradient(to right, #f94a5b, #808af1 100%);
  font-family: "PT Sans", sans-serif;
  color: #fff;
  background-size: 100%;
  background-repeat: repeat-y;
  border-radius: 4px;
  border: none;
  outline: 0;
  transition: all 0.3s ease-out;
  justify-content: center;
  &:hover {
    background-size: 370%;
    background-position: unset;
  }
  &.mobile {
    margin: 0;
    width: 49%;
  }
`
export const HollowButton = styled.button`
  width: 100%;
  margin: 0;
  padding: 10px 0;
  vertical-align: middle;
  box-sizing: border-box;
  background-clip: padding-box, border-box;
  background-origin: padding-box, border-box;
  border: 1px solid transparent;
  background-image: linear-gradient(#ffffff, #ffffff), linear-gradient(80deg, #f94a5b 0%, #808af1);
  transition-duration: 0.2s;
  transition-property: background-image;
  transition: 0.2s all linear;
  border-radius: 4px;
  > ${ButtonText} {
    background: linear-gradient(80deg, #f94a5b 0%, #808af1);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    transition: 0.2s all linear;
    font-family: "PT Sans", sans-serif;
  }
  &.btnOrder {
    margin-top: 0;
  }
  &.btnResumo {
    margin-top: 20px;
    margin-bottom: 40px;
  }
  &.btnCancel {
    border: 0;
    padding: 20px 0;
  }
  &.mobile {
    width: 49%;
    padding: 0;
  }
`

export const OrderCard = styled.div`
  border-radius: 13px;
  border: 1px solid #e4e4e4;
  background: #fff;
  margin: 20px;
  padding-bottom: 20px;
  box-sizing: border-box;
  overflow: hidden;
  @media (max-width: 991.98px) {
    margin: 7px;
  }
`

export const OrderDetails = styled.div`
  border-radius: 13px;
  border: 2px solid #e4e4e4;
  box-sizing: border-box;
  overflow: hidden;
`

export const OrderHeader = styled.div`
  margin: 1rem 1rem 1rem 1.5rem;
  display: flex;
  height: 25px;
  width: 100%;
`

export const OrderTitle = styled.h2`
  font-weight: 700;
  font-size: 20px;
  flex: none;
`

export const OrderDivider = styled.div`
  color: #e4e4e4;
  margin: 0.5rem 0 0 0.5rem;
  width: 100%;
  border-bottom: 1px #e4e4e4 solid;
`

export const OrderSummary = styled.div`
  width: 100%;
`

export const Resumo = styled.div`
  margin-right: 20px;
  border: 1px solid #e4e4e4;
  background-color: #fff;
  box-sizing: border-box;
  border-radius: 13px;
  padding: 40px;
  &.mobile {
    padding: 0;
    padding-top: 20px;
    margin: 0;
    border: 0;
  }
`

export const Title = styled.h1`
  font-family: "PT Sans", sans-serif;
  font-weight: 700;
  font-size: 2rem;
  color: #6079d6;
  text-align: center;
  margin-bottom: 1.5rem;
  &.mobile {
    font-size: 22px;
    text-align: left;
    margin-bottom: 0.5rem;
  }
`

export const Text = styled.p`
  font-family: "PT Sans", sans-serif;
  border-bottom: 1px solid #e4e4e4;
  margin: 0;
  padding: 5px 0;
  font-weight: 400;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  &.mobile {
    padding-bottom: 10px;
  }
`

export const Quantity = styled.span`
  font-size: 17px;
  color: #535353;
  float: right;
`

export const Total = styled.span`
  font-size: 26px;
  color: #535353;
  float: right;
`
